// =============================================
// DemandBadge — colored badge for demand_tier
// =============================================

import { Badge } from "@/components/ui/badge";
import type { DemandTier } from "@/types/thematicMaps";

const TIER_STYLES: Record<DemandTier, { className: string; label: string }> = {
  clearly_validated: { className: "bg-green-500/15 text-green-700 dark:text-green-400 border-green-500/30", label: "CV" },
  validated_moderate: { className: "bg-yellow-500/15 text-yellow-700 dark:text-yellow-400 border-yellow-500/30", label: "VM" },
  weak_signal: { className: "bg-orange-500/15 text-orange-700 dark:text-orange-400 border-orange-500/30", label: "WS" },
  no_demand: { className: "bg-red-500/15 text-red-700 dark:text-red-400 border-red-500/30", label: "ND" },
  unknown: { className: "bg-muted text-muted-foreground border-border", label: "?" },
};

const TIER_LABELS: Record<DemandTier, string> = {
  clearly_validated: "Clearly Validated",
  validated_moderate: "Validated Moderate",
  weak_signal: "Weak Signal",
  no_demand: "No Demand",
  unknown: "Nie zwalidowany",
};

interface DemandBadgeProps {
  tier: DemandTier;
  compact?: boolean;
  showScore?: boolean;
  score?: number | null;
}

export function DemandBadge({ tier, compact = false, showScore, score }: DemandBadgeProps) {
  const style = TIER_STYLES[tier] || TIER_STYLES.unknown;

  return (
    <Badge
      variant="outline"
      className={`shrink-0 text-xs ${style.className}`}
      title={TIER_LABELS[tier]}
    >
      {compact ? style.label : TIER_LABELS[tier]}
      {showScore && score != null && ` (${score.toFixed(1)})`}
    </Badge>
  );
}
